import * as angular from "angular";

export class LoginService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/login";
    }

    all(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all/" + data.id, {
            params: data,
        });
    }

    count(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/count/" + data.id, {
            params: data,
        });
    }
}

angular.module("vcServices").service("LoginService", LoginService);
